﻿import InfoCardLoader from "../../deprecatedUikit/InfoCard/InfoCardLoader";

const SupplierCurrentInventoryCardListLoader = () => Array.from({ length: 10 }).map((_, index) =>(
  <InfoCardLoader key={index} />
));

export { SupplierCurrentInventoryCardListLoader };
